import $ from 'jquery'

class FrameOne {
	//? 1. describe and create/initiate our object

	constructor() {
		//Verables
		this.events()
	}

	//?events
	events() {
		let myObj = this

		$(document).ready(function () {
			myObj.FrameOneFunction()
			myObj.FrameTwoFunction()
		})
	}

	//? 3. methods (functions)
	FrameOneFunction() {
		let num = 0

		let mobileLink = './wp-content/uploads/frameOne/computer kibisi_'
		let descktopLink = './wp-content/uploads/frameOne/computer kibisi_'
		let activeURL = mobileLink
		let resposiveOffset = 0
		if (window.outerWidth > 600) {
			activeURL = descktopLink
			resposiveOffset = 120
		}

		var images = [
			`${activeURL}090.png`,
			`${activeURL}091.png`,
			`${activeURL}092.png`,
			`${activeURL}093.png`,
			`${activeURL}094.png`,
			`${activeURL}095.png`,
			`${activeURL}096.png`,
			`${activeURL}097.png`,
			`${activeURL}098.png`,
			`${activeURL}099.png`,
			`${activeURL}100.png`,
			`${activeURL}101.png`,
			`${activeURL}102.png`,
			// `${activeURL}103.png`,
			// `${activeURL}104.png`,
			// `${activeURL}105.png`,
			// `${activeURL}106.png`,
			// `${activeURL}107.png`,
			// `${activeURL}108.png`,
			// `${activeURL}109.png`,
			// `${activeURL}110.png`,
			// `${activeURL}111.png`,
			// `${activeURL}112.png`,
			// `${activeURL}113.png`,
			// `${activeURL}114.png`,
			// `${activeURL}115.png`,
			// `${activeURL}116.png`,
			// `${activeURL}117.png`,
			// `${activeURL}118.png`,
			// `${activeURL}119.png`,
			// `${activeURL}120.png`,
			// `${activeURL}121.png`,
			// `${activeURL}122.png`,
			// `${activeURL}123.png`,
			// `${activeURL}124.png`,
			// `${activeURL}125.png`,
			// `${activeURL}126.png`,
			// `${activeURL}127.png`,
			// `${activeURL}128.png`,
			// `${activeURL}129.png`,
			// `${activeURL}130.png`,
			// `${activeURL}131.png`,
			// `${activeURL}132.png`,
			// `${activeURL}133.png`,
			// `${activeURL}134.png`,
			// `${activeURL}135.png`,
			// `${activeURL}136.png`,
			// `${activeURL}137.png`,
			// `${activeURL}138.png`,
			// `${activeURL}139.png`,
			// `${activeURL}140.png`,
			// `${activeURL}141.png`,
			// `${activeURL}142.png`,
			// `${activeURL}143.png`,
			// `${activeURL}144.png`,
			// `${activeURL}145.png`,
			// `${activeURL}146.png`,
			// `${activeURL}147.png`,
			// `${activeURL}148.png`,
			// `${activeURL}149.png`,
			// `${activeURL}150.png`,
			// `${activeURL}151.png`,
			// `${activeURL}152.png`,
			// `${activeURL}153.png`,
			// `${activeURL}154.png`,
			// `${activeURL}155.png`,
			// `${activeURL}156.png`,
			// `${activeURL}157.png`,
			// `${activeURL}158.png`,
			// `${activeURL}159.png`,
			// `${activeURL}160.png`,
			// `${activeURL}161.png`,
			// `${activeURL}162.png`,
			// `${activeURL}163.png`,
			// `${activeURL}164.png`,
			// `${activeURL}164.png`,
			// `${activeURL}166.png`,
			// `${activeURL}167.png`,
			// `${activeURL}168.png`,
			// `${activeURL}169.png`,
			// `${activeURL}170.png`,
			// `${activeURL}171.png`,
			// `${activeURL}172.png`,
			// `${activeURL}173.png`,
			// `${activeURL}174.png`,
			// `${activeURL}175.png`,
			// `${activeURL}176.png`,
			// `${activeURL}177.png`,
		]

		function preloadImages(images) {
			for (let i = 0; i < images.length; i++) {
				let l = document.createElement('link')
				l.rel = 'preload'
				l.as = 'image'
				l.href = images[i]
				document.head.appendChild(l)
			}
		}

		preloadImages(images)

		function pad(num, size) {
			num = num.toString()
			while (num.length < size) num = '0' + num
			return num
		}
		// console.log(images);
		var obj = { curImg: 0 }

		// create tween
		var tween = TweenMax.to(obj, 0.5, {
			curImg: images.length - 1, // animate propery curImg to number of images
			roundProps: 'curImg', // only integers so it can be used as an array index
			// repeat: 0, // repeat 3 times
			immediateRender: true, // load first image automatically
			ease: Linear.easeNone, // show every image the same ammount of time
			onUpdate: function () {
				$('.imgSequince').attr('src', images[obj.curImg]) // set the image source
			},
		})

		let offSetNum = window.innerHeight / 2
		var controller = new ScrollMagic.Controller()

		// build scene
		var scene = new ScrollMagic.Scene({
			triggerElement: '#frame-one',
			offset: window.innerHeight / 2,
			duration: 2000,
		})
			.addIndicators({
				name: ' cans',
				colorTrigger: 'red',
				colorStart: 'red',
				colorEnd: 'red',
				indent: 200,
			})
			.setTween(tween)
			.setPin('#frame-one')
			.addTo(controller)
	}

	FrameTwoFunction() {
		let num = 0

		let mobileLink = './wp-content/uploads/frameTwo/computer kibisi_'
		let descktopLink = './wp-content/uploads/frameTwo/computer kibisi_'
		let activeURL = mobileLink
		let resposiveOffset = 0
		if (window.outerWidth > 600) {
			activeURL = descktopLink
			resposiveOffset = 120
		}

		var images = [
			`${activeURL}189.png`,
			`${activeURL}190.png`,
			`${activeURL}191.png`,
			`${activeURL}192.png`,
			`${activeURL}193.png`,
			`${activeURL}194.png`,
			`${activeURL}195.png`,
			`${activeURL}196.png`,
			`${activeURL}197.png`,
			`${activeURL}198.png`,
			`${activeURL}199.png`,
			`${activeURL}200.png`,
			`${activeURL}201.png`,
			`${activeURL}202.png`,
			`${activeURL}203.png`,
			`${activeURL}204.png`,
			`${activeURL}205.png`,
			`${activeURL}206.png`,
			`${activeURL}207.png`,
			`${activeURL}208.png`,
			`${activeURL}209.png`,
			`${activeURL}210.png`,
			`${activeURL}211.png`,
			`${activeURL}212.png`,
			`${activeURL}213.png`,
			`${activeURL}214.png`,
			`${activeURL}215.png`,
			`${activeURL}216.png`,
			`${activeURL}217.png`,
			`${activeURL}218.png`,
			`${activeURL}219.png`,
			`${activeURL}220.png`,
			`${activeURL}221.png`,
			`${activeURL}222.png`,
			`${activeURL}223.png`,
			`${activeURL}224.png`,
			`${activeURL}225.png`,
			`${activeURL}226.png`,
			`${activeURL}227.png`,
			`${activeURL}228.png`,
			`${activeURL}229.png`,
			`${activeURL}230.png`,
			`${activeURL}231.png`,
			`${activeURL}232.png`,
			`${activeURL}233.png`,
			`${activeURL}234.png`,
			`${activeURL}235.png`,
			`${activeURL}236.png`,
			`${activeURL}237.png`,
			`${activeURL}238.png`,
			`${activeURL}239.png`,
			`${activeURL}240.png`,
			`${activeURL}241.png`,
			`${activeURL}242.png`,
			`${activeURL}243.png`,
			`${activeURL}244.png`,
			`${activeURL}245.png`,

			`${activeURL}246.png`,
			`${activeURL}247.png`,
			`${activeURL}248.png`,
			`${activeURL}249.png`,
			`${activeURL}250.png`,
			`${activeURL}251.png`,
			`${activeURL}252.png`,
			`${activeURL}253.png`,
			`${activeURL}254.png`,
			`${activeURL}255.png`,
		]

		function preloadImages(images) {
			for (let i = 0; i < images.length; i++) {
				let l = document.createElement('link')
				l.rel = 'preload'
				l.as = 'image'
				l.href = images[i]
				document.head.appendChild(l)
			}
		}

		preloadImages(images)

		function pad(num, size) {
			num = num.toString()
			while (num.length < size) num = '0' + num
			return num
		}
		// console.log(images);
		var obj = { curImg: 0 }

		// create tween
		var tween = TweenMax.to(obj, 0.5, {
			curImg: images.length - 1, // animate propery curImg to number of images
			roundProps: 'curImg', // only integers so it can be used as an array index
			// repeat: 0, // repeat 3 times
			immediateRender: true, // load first image automatically
			ease: Linear.easeNone, // show every image the same ammount of time
			onUpdate: function () {
				$('.imgSequince-frameTwo').attr('src', images[obj.curImg]) // set the image source
			},
		})

		let offSetNum = window.innerHeight / 2
		var controller = new ScrollMagic.Controller()

		// build scene
		var scene = new ScrollMagic.Scene({
			triggerElement: '#frame-two',
			offset: window.innerHeight / 2,
			duration: 2000,
		})
			.addIndicators({
				name: ' cans',
				colorTrigger: 'red',
				colorStart: 'red',
				colorEnd: 'red',
				indent: 200,
			})
			.setTween(tween)
			.setPin('#frame-two')
			.addTo(controller)
	}
}

export default FrameOne
